import { v4 as uuidv4 } from 'uuid';
import { getInactiveSubscriptionsAPI } from './api';

async function getInactiveSubscriptions() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    const res = await getInactiveSubscriptionsAPI({
        store: this,
        token: session.token,
        traceId,
        page: this.page,
    });

    if (res.error) return;

    if (res?.data?.data?.results) {
        this.inactiveSubscriptions = [
            ...this.inactiveSubscriptions,
            ...res.data.data.results,
        ];

        this.observed.subscriptions = uuidv4();
    }
}

export default getInactiveSubscriptions;
